import { ChangeEvent } from 'react';
import heic2any from 'heic2any';

export const acceptNumeric =
    (cb: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void) => (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
        new RegExp('^[0-9]*$').test(e.currentTarget.value) && cb(e);

export const checkFileAccept = (accept: string, file: File): { accepted: boolean; format: string | null } => {
    const mimeMap: Record<string, string> = {
        '.jpg': 'image/jpeg',
        '.jpeg': 'image/jpeg',
        '.png': 'image/png',
        '.heic': 'image/heic'
    };

    const acceptArray = accept.split(',').map(ext => ext.trim().toLowerCase());

    const fileType = file.type;

    const matchedExt = acceptArray.find(ext => mimeMap[ext] === fileType);

    return {
        accepted: !!matchedExt,
        format: matchedExt ? mimeMap[matchedExt] : null
    };
};

export const processImageWithConvert = async (file: File): Promise<File> => {
    if (file.type !== 'image/heic' && !file.name.toLowerCase().endsWith('.heic')) return file;

    try {
        const convertedBlob = await heic2any({
            blob: file,
            toType: 'image/jpeg',
            quality: 0.8
        });

        const newFileName = file.name.toLowerCase().endsWith('.heic')
            ? file.name.substring(0, file.name.length - 5) + '.jpg'
            : file.name.replace(/\.(heic|HEIC)$/i, '.jpg');

        if (convertedBlob) {
            const blob = Array.isArray(convertedBlob) ? convertedBlob[0] : convertedBlob;
            return new File([blob as Blob], newFileName, { type: 'image/jpeg' });
        }

        return file;
    } catch (error) {
        throw new Error('HEIC_PROCESSING_FAILED');
    }
};
